export function LogoMark({ className = "h-8 w-8" }) {
  return <img src="/logo-letter-dark.png" alt="Sitebound" className={className} />;
}

export function LogoFull({ className = "", imgClass = "h-10" }) {
  return (
    <img
      src="/logo-full-dark.png"
      alt="Sitebound — Australian Construction Careers"
      className={`${imgClass} w-auto ${className}`}
    />
  );
}
